import React from 'react'
import Page from './page'
import './theaters.css'

function Theaters () {
  return (
    <Page>
      <header className="theaters-header">
        <h1>Theaters</h1>
        <p>Available Now on <a href="https://itunes.apple.com/us/movie/dig-two-graves/id1167254804?ls=1" target="_blank" rel="noopener noreferrer">iTunes</a></p>
      </header>
      <section>
        <header className="theaters-subheader">
          <h3>Now Playing</h3>
        </header>
        <dl>
          <dt>Marion, IL</dt>
          <dd><a href="http://digtwogravesfilm.bpt.me" target="_blank" rel="noopener noreferrer">April 15th at Marion Cultural Civic Center</a></dd>
          <dt>Cleveland, OH</dt>
          <dd><a href="http://www.clevelandcinemas.com/movie/204792/Dig-Two-Graves-Trailer-and-Info" target="_blank" rel="noopener noreferrer">April 18th at Capitol Theatre</a></dd>
          <dt>Columbus, OH</dt>
          <dd><a href="http://gatewayfilmcenter.org" target="_blank" rel="noopener noreferrer">April 21-27 at Gateway Film Center</a></dd>
          <dt>Edinburgh, Scotland</dt>
          <dd><a href="http://www.filmhousecinema.com/showing/dig-two-graves-apr17" target="_blank" rel="noopener noreferrer">April 23rd Dead By Dawn Film Festival</a></dd>
        </dl>
        <p>More cities to come.</p>
      </section>
      <section>
        <header className="theaters-subheader">
          <h3>Past Theatrical Screenings</h3>
        </header>
        <dl>
          <dt>Atlanta</dt>
          <dd>AMC North Dekalb Mall 16</dd>
          <dt>Chicago</dt>
          <dd>AMC River East 21</dd>
          <dt>Dallas</dt>
          <dd>AMC Mesquite 30</dd>
          <dt>Houston</dt>
          <dd>AMC Studio 30</dd>
          <dt>Los Angeles</dt>
          <dd>Laemmle Music Hall</dd>
          <dt>New York City</dt>
          <dd>Cinema Village</dd>
          <dt>Phoenix</dt>
          <dd>AMC Arizona Center 24</dd>
          <dt>Tampa</dt>
          <dd>AMC Veterans Expressway 24</dd>
          <dt>Washington, DC</dt>
          <dd>AMC Hoffman 22</dd>
        </dl>
      </section>
    </Page>
  )
}

export default Theaters



// WEBPACK FOOTER //
// ./src/components/theaters.js